<!-- 
Panel for signing in.
-->
<template>
  <div>
    <v-form ref="form">
      <v-card>
        <our-busy-indicator :show="state.busy" />
        <v-card-text>
          <v-container grid-list-xl pa-3>
            <v-layout wrap>
              <v-flex class="xs12 py-1">
                <v-text-field 
                  id="sign-in-email-address" ref="email" 
                  :value="signInDetails.email" :rules="[rules.email, rules.required]" 
                  label="Email address" required 
                  validate-on-blur maxlength="300" autofocus 
                  @input="update('email', $event)"
                />
              </v-flex>
              <v-flex class="xs12 pt-1 pb-0">
                <v-text-field 
                  id="sign-in-password" ref="password" 
                  :value="signInDetails.password"
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  :rules="[rules.required]" 
                  :type="showPassword ? 'text' : 'password'"
                  name="input-10-1" label="Password" autocomplete="off" required 
                  @click:append="showPassword = !showPassword" @input="update('password', $event)"
                />
              </v-flex>
              <v-flex class="xs12 py-0">
                <a href="https://prisms.education.gov.au/Logon/ForgottenPassword.aspx" target="_blank">Forgotten your password?</a>
              </v-flex>
            </v-layout>
          </v-container>
          <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" :state-error="state.error" show-security-errors />
        </v-card-text>
        <v-card-actions>
          <v-flex shrink class="ml-3">
            <our-user-guide-button topic="common" section="signing-in"/>
          </v-flex>
          <v-flex grow class="text-xs-right pr-4 my-3">
            <v-btn 
              id="sign-in-button"
              ref="sign-in-button"
              :disabled="state.busy" 
              type="submit" class="ml-0 mr-2" color="primary" 
              @click.prevent="signIn"
            >
              Sign in
            </v-btn>
            <v-menu v-if="testingToolsEnabled" bottom offset-y>
              <v-btn slot="activator" :disabled="state.busy" color="default" @click="clear">
                Testing tools
                <v-icon>keyboard_arrow_down</v-icon>
              </v-btn>
              <v-list>
                <v-subheader>Sign in as sample user</v-subheader>
                <v-list-tile
                  v-for="(user, index) in users"
                  :key="index"
                  @click="logonWithSample(user)"
                >
                  <v-list-tile-title>{{ user }}</v-list-tile-title>
                </v-list-tile>
                <v-divider/>
                <v-list-tile to="/testing-tools-anonymous">
                  <v-list-tile-title>Other testing tools</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import * as mutation from "@/store/users/mutation-types";
import * as action from "@/store/users/action-types";
import * as systemAction from "@/store/system/action-types";
import ruleMixins from "@/mixins/rule.mixins";
import { SIGN_IN_SET_REDIRECT } from "@/store/users/mutation-types";

export default {
  mixins: [ruleMixins],
  data() {
    return {
      showValidationDialog: false,
      showPassword: false,
      users: ["ltps-user@education.gov.au", "ltps-business-admin@education.gov.au", "ltps-it-admin@education.gov.au"]
    };
  },
  computed: {
    state() {
      return this.$store.state.users.user;
    },
    testingToolsEnabled() {
      return this.$store.getters.testingToolsEnabled;
    },
    signInDetails() {
      return this.state.data;
    }
  },
  mounted() {
    // we want to get the latest system details occasionally so we can ensure that the UI is up-to-date
    this.$store.dispatch(systemAction.SYSTEM_DETAILS_REFRESH, true);
  },
  methods: {
    logonWithSample(email) {
      this.$refs.form.reset();
      this.update("email", email);
      this.update("password", "password");
      this.signInAction();
    },
    signIn() {
      this.showValidationDialog = !this.$refs.form.validate();
      if (!this.showValidationDialog) {
        this.signInAction();
      }
    },
    async signInAction() {
      if (await this.$store.dispatch(action.SIGN_IN)) {
        let redirect = this.$store.state.users.user.redirect;
        if (redirect) {
          this.$store.commit(SIGN_IN_SET_REDIRECT, null);
        } else {
          redirect = "/";
        }
        this.$router.push({ path: redirect });
        this.$emit("changed");
      } else {
        this.showValidationDialog = true;
      }
    },
    update(field, newValue) {
      this.$store.commit(mutation.SIGN_IN_SET_DATA, { [field]: newValue });
    },
    clear() {
      this.update("email", "");
      this.update("password", "");
      this.$refs.form.reset();
    }
  }
};
</script>
